/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Files_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Drag files directly into this area, or use the toolbar to upload and create folders. If the space is connected to a cloud source, syncing brings its files in..." |
*
* @param {Uno_Edu_Space_Files_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_files_chip1_answer = /** @type {((inputs?: Uno_Edu_Space_Files_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Files_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehen Sie Dateien direkt in diesen Bereich oder verwenden Sie die Symbolleiste zum Hochladen und Erstellen von Ordnern. Ist der Space mit einer Cloud-Quelle verbunden, bringt die Synchronisierung dessen Dateien automatisch herein.")
	return /** @type {LocalizedString} */ ("Drag files directly into this area, or use the toolbar to upload and create folders. If the space is connected to a cloud source, syncing brings its files in automatically.")
});